import { service } from "../server/request";

export const getNaSettingsById = async (catererId) => {
    try {
        const url = `/mealManage/catererAnalysisSettings/search/findByCatererAnalysisId?catererAnalysisId=${catererId}`
        const resp = await service({
            method: 'GET',
            url: url
        });
        if (resp.status === 200) {
            const respObj = ((resp.data._embedded.catererAnalysisSettings || [])[0] || {});
            return {
                success: true, data: {
                    ...respObj,
                    sodiumLevel: (respObj.sodiumLevel || '').length > 0 ? JSON.parse(respObj.sodiumLevel) : [],
                    productionRecordSettings: (respObj.productionRecordSettings || '').length > 0 ? JSON.parse(respObj.productionRecordSettings) : [],
                    id: respObj._links ? respObj._links.self.href.split('/').pop() : 0
                }
            };
        }
    } catch (ex) {
        return { error: true, errorMessage: ex.message }
    }
}
// The Production Record Settings table is configured once per school under Nutrition Analysis
// Settings. The production record screen reads every flag back as one
// { [mealSchoolId]: { ovsEnabled, leftOverCodeEnabled } } map so nothing has to be set day by day.
export const getProductionRecordSettingsMap = async (catererId) => {
    const resp = await getNaSettingsById(catererId);
    if (!resp || resp.error) {
        return { error: true, errorMessage: (resp || {}).errorMessage };
    }
    const settingsMap = {};
    (((resp.data || {}).productionRecordSettings) || []).forEach(rec => {
        settingsMap[rec.mealSchoolId] = {
            ovsEnabled: rec.ovsEnabled || false,
            leftOverCodeEnabled: rec.leftOverCodeEnabled || false
        };
    });
    return { success: true, data: settingsMap };
}
export const saveSettingsRec = async (req, recId) => {
    try {
        const url = `/mealManage/catererAnalysisSettings/${recId}`;
        const resp = await service({
            method: 'PUT',
            data: req,
            url: url,
        });
        if (resp.status == 200) {
            return { success: true, data: { ...resp.data, message: "Record saved successfully." } };
        } else {
            return { error: true, errorMessage: resp.data.errorMessage };
        }
    } catch (ex) {
        const errorObject = ex;
        const errorMessage = errorObject.message;
        return { error: true, errorMessage: errorMessage }
    }
}
export const insertSettingsRec = async (req) => {
    try {
        const url = `/mealManage/catererAnalysisSettings`
        const resp = await service({
            method: 'POST',
            data: req,
            url: url,
        });
        if (resp.status == 201) {
            return { success: true, data: { ...resp.data, message: "Record saved successfully." } };
        } else {
            return { error: true, errorMessage: resp.data.errorMessage };
        }
    } catch (ex) {
        const errorObject = ex;
        const errorMessage = errorObject.message;
        return { error: true, errorMessage: errorMessage }
    }
}